const codes = {
  userName: "JohnSmith",
  googlePlay: "./images/googlePlay.svg",
  appStore: "./images/appStore.svg",
  category: {
    rideSharing: {
      uber: {
        img: "./images/uber.svg",
        alt: "Uber",
        code: "HKFD873",
        darkLogo: true,
        googlePlayLink:
          "https://play.google.com/store/apps/details?id=com.ubercab&hl=en_CA",
        appStoreLink: "https://apps.apple.com/ca/app/uber/id368677368"
      },
      lyft: {
        img: "./images/lyft.svg",
        alt: "Lyft",
        code: "HkfKds3"
      }
    },
    foodDelivery: {
      foodora: {
        img: "./images/foodora.svg",
        alt: "Foodora",
        code: "djsfkh73"
      },
      doorDash: {
        img: "./images/doorDash.svg",
        alt: "Door Dash",
        code: "kjfd83"
      },
      uberEats: {
        img: "./images/uberEats.png",
        alt: "Uber Eats",
        code: "LKFJD9",
        darkBackground: false
      }
    },
    foodPickup: {
      ritual: {
        img: "./images/ritual.svg",
        alt: "Ritual",
        code: "HJKFDS83",
        darkLogo: true
      },
      feedback: {
        img: "./images/feedback.svg",
        alt: "Feedback",
        code: "Hjfdl"
      }
    },
    financialServices: {
      payTM: {
        img: "./images/paytm.png",
        alt: "payTM",
        code: "9823kds"
      }
    },
    grocery: {
      walmart: {
        img: "./images/walmart.svg",
        alt: "Walmart",
        code: "LKfdsjk9"
      },
      instacart: {
        img: "./images/instacart.svg",
        alt: "InstaCard",
        code: "LKfdsjk9"
      }
    }
  }
};

export default codes;
